const underscore_now = Date.now || function() {
    // A (possibly faster) way to get the current timestamp as an integer.
    return new Date().getTime();
};

export { underscore_now }